/**
 * Implementación del repositorio de Work usando HTTP
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';
import { WorkRepository } from '@domain/repositories/work.repository';
import {
  Work,
  TopVideoWork,
  CreateWorkResponse
} from '@domain/models/work.model';
import {
  CreateWorkResponseDto,
  MyWorkItemDto,
  TopVideoWorkDto
} from '@infra/dto/work.dto';
import {
  WorkMapper,
  TopVideoWorkMapper,
  CreateWorkResponseMapper
} from '@infra/mappers/work.mapper';

function joinUrl(base: string, path: string) {
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

@Injectable({ providedIn: 'root' })
export class WorkRepositoryImpl implements WorkRepository {
  private http = inject(HttpClient);
  private readonly baseUrl = joinUrl(environment.apiUrl, '/v1/works');

  createWork(formData: FormData): Observable<CreateWorkResponse> {
    return this.http.post<CreateWorkResponseDto>(this.baseUrl, formData).pipe(
      map(dto => CreateWorkResponseMapper.toDomain(dto))
    );
  }

  getMyWorks(): Observable<Work[]> {
    return this.http.get<MyWorkItemDto[]>(joinUrl(this.baseUrl, 'my')).pipe(
      map(dtos => WorkMapper.toDomainList(dtos))
    );
  }

  getTopVideos(): Observable<TopVideoWork[]> {
    return this.http.get<TopVideoWorkDto[]>(joinUrl(this.baseUrl, 'top-videos')).pipe(
      map(dtos => TopVideoWorkMapper.toDomainList(dtos))
    );
  }

  deleteWork(workId: string): Observable<void> {
    const url = joinUrl(this.baseUrl, 'delete') + `?workId=${encodeURIComponent(workId)}`;
    return this.http.patch<void>(url, {});
  }
}

